module.exports = __webpack_public_path__ + "img/setup-test-step-2-desktop.bf2911c5.png";